import Vue from 'vue';
import Vuex from 'vuex';

import config from './config';
import dealers from './dealers';
import models from './models';
import assistants from './assistants';
import rss from './rss';
import indicators from './indicators';
import accessories from './accessories';
import inspections from './inspections';
import util from './util';
import user from './user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    config,
    dealers,
    models,
    assistants,
    rss,
    indicators,
    accessories,
    inspections,
    util,
    user,
  },
});
